export default __webpack_public_path__ + "static/media/product-pc-1.ecc3c088.png";